export default __webpack_public_path__ + "static/media/ri_gscholar.615c6993.svg";